import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import AboutVission from '../../../assets/about-us/about-vission.png'
import AboutMission from '../../../assets/about-us/about-mission.png'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMVissionAndMission: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                backgroundColor: '#FFFFFF',
            }}
        >
            {/* VISSION */}
            <Box sx={{
                flex: '1',
                backgroundColor: '#FFF8E7',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '30px',
                paddingTop: '35px',
                paddingRight: '30px',
                paddingBottom: '64px',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                    <Image src={AboutVission} width={80} height={80} alt='' preview={false}></Image>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'} paddingLeft={'25px'}>{t('t101')}</Typography>
                </Box>

                <Box sx={{
                    paddingTop: '25px',
                }}>
                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'}>
                    {t('t102')}
                    </Typography>
                </Box>

            </Box>

            <Box sx={{
                width: '25px',
            }}></Box>

            {/* MISSION */}
            <Box sx={{
                flex: '1',
                backgroundColor: '#FFF8E7',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '30px',
                paddingTop: '35px',
                paddingRight: '30px',
                paddingBottom: '64px',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                    <Image src={AboutMission} width={80} height={80} alt='' preview={false}></Image>
                    <Typography fontSize={20} fontWeight={600} color={'#141F39'} paddingLeft={'25px'}>{t('t103')}</Typography>
                </Box>

                <Box sx={{
                    paddingTop: '25px',
                }}>
                    <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'}>
                        {t('t104')}
                    </Typography>
                </Box>

            </Box>

        </Box>
    )
}

// ======================= EXPORT
export default SMVissionAndMission
